const AFRAME = window.AFRAME;
const THREE = AFRAME.THREE;


AFRAME.registerComponent( 'log_gltf', {

	init() {

		console.log( this.el.id, this.el.object3DMap );

	}

} );
